<template>
    <div class="not-find">404</div>
</template>

<script>
    export default {
        name: 'NotFind',
    };
</script>

<style scoped lang="less">
    .not-find {
        background-color: #000;
        width: 100vw;
        height: 100vh;
    }
</style>
